<template>
    <loading v-model:active="isLoading">

        <div class="loader-wrapper">
            <div class="row loader-img">
                <div class="col-12 status_bar">
                    <img src="../assets/images/logo/Suploader.gif" class="loader_img" alt="">
                    <span class="loader">Loading</span>
                </div>
            </div>
        </div>
        <!--<div id="preloader" class="preloader ">
        <button class="gt-btn style2 preloaderCls">Cancel Preloader </button>
        <div id="loader" class="gt-preloader">
            <div class="animation-preloader">
                <div class="icon text-center">
                    <img class="mb-3" src="../assets/Theme/CSS/img/icon/icon1.png" alt="icon">
                </div>
                <div class="txt-loading">
                    <span data-preloader-text="B" class="characters">B</span>
                    <span data-preloader-text="E" class="characters">E</span>
                    <span data-preloader-text="E" class="characters">E</span>
                    <span data-preloader-text="N" class="characters">N</span>
                    <span data-preloader-text="I" class="characters">I</span>
                    <span data-preloader-text="F" class="characters">F</span>
                    <span data-preloader-text="Y" class="characters">Y</span>
                </div>
            </div>
        </div>
    </div>-->
    </loading>
</template>
<script>
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/css/index.css';
    export default {
        props: {
            isLoading: Boolean,
        },
        components: {
            Loading
        },
        data() {
            return {
                isLoading: false,
            }
        },
        created() {
            /*this.vmodeldata = this.editordata*/
        }
    }
</script>
<style>

</style>